var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 60,
    viewBox: "0 0 72 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.8261 59.0004H13.1739C6.47826 59.0004 1 53.5057 1 48.3162V1.00043H25.3478L31.4348 10.1583H71V46.7899C71 53.5057 65.5217 59.0004 58.8261 59.0004Z",
    stroke: "#338FCE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.715 46.7899H31.2802C28.8454 46.7899 26.8672 44.8057 26.8672 42.3636V31.5267H45.1281V42.3636C45.1281 44.8057 43.1498 46.7899 40.715 46.7899Z",
    stroke: "#338FCE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4336 31.5268V26.9478C31.4336 24.3531 33.4119 22.3689 35.9988 22.3689C38.5858 22.3689 40.564 24.3531 40.564 26.9478V31.5268",
    stroke: "#338FCE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderLocked);
export default __webpack_public_path__ + "static/media/folderLocked.909d145c04a78374251b8188845dbacf.svg";
export { ForwardRef as ReactComponent };